import { apiClient } from './client';
import type {
  CompleteProfileRequest,
  ForgotPasswordRequest,
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  ResetPasswordRequest,
  VerifyEmailResponse,
} from '../types/api';

export const authApi = {
  register: (body: RegisterRequest) =>
    apiClient.post<{ message: string }>('/auth/register', body),

  verifyEmail: (token: string) =>
    apiClient.get<VerifyEmailResponse>(`/auth/verify-email?token=${encodeURIComponent(token)}`),

  completeProfile: (body: CompleteProfileRequest) =>
    apiClient.post<{ message: string }>('/auth/complete-profile', body),

  login: (body: LoginRequest) => apiClient.post<LoginResponse>('/auth/login', body),

  logout: () => apiClient.post<{ message: string }>('/auth/logout', {}),

  forgotPassword: (body: ForgotPasswordRequest) =>
    apiClient.post<{ message: string }>('/auth/forgot-password', body),

  resetPassword: (body: ResetPasswordRequest) =>
    apiClient.post<{ message: string }>('/auth/reset-password', body),
};
